import tacHelpers from '../tacHelpers';
import addItem from './addItem';

// ITEMS
export function addMultipleItems(state, items, parent, options) {
  let model = state;

  items.forEach(item => {
    let updParent;
    if (item.parentRef) {
      updParent = tacHelpers.getItem(model, item.parentRef);
      delete item.parentRef;
    } else if (parent) {
      updParent = tacHelpers.getItem(model, parent.itemid);
    }
    model = addItem(model, item, updParent, options);
  });

  return model;
}
